<template>
  <div>
    <!-- banner -->
    <banner :items="items"></banner>
    <fix-nav @switch="switchItem" :currentIndex="currentIndex"></fix-nav>
    <div class="container">
      <!-- tab-switch -->
      <switches :switches="switches" @switch="switchItem" :currentIndex="currentIndex" :para="para"></switches>
    </div>
    <!-- site-main -->
    <div id="site-main">
      <market v-if="currentIndex===0"></market>
      <consultation v-if="currentIndex===1"></consultation>
    </div>
    <!-- footer -->
    <t-footer :infos="infos"></t-footer>
  </div>
</template>
<script>
import banner from '@/components/picSwipe'
import switches from '@/base/switches'
import TFooter from '@/view/training/footer'
import market from '@/view/training/market'
import consultation from '@/view/training/consultation'
import fixNav from '@/view/training/fixnav'
import utils from '@/util/WXshare'
import { mapMutations } from 'vuex'
export default {
  data () {
    return {
      currentIndex: 0,
      infos: {
        0: [{
          icon: '&#xe613;',
          word: '整合营销服务顾问：Yolanda ( 汪丹 )'
        }, {
          icon: '&#xe612;',
          word: '手机：13426412029'
        }, {
          icon: '&#xe611;',
          word: '邮箱：hezuo@geekbang.org'
        }],
        1: [{
          icon: '&#xe613;',
          word: '企业咨询服务顾问： Rodin（罗丹)'
        }, {
          icon: '&#xe612;',
          word: '电话：15002200534'
        }, {
          icon: '&#xe611;',
          word: '邮箱：rodin@geekbang.org'
        }]
      }
    }
  },
  created () {
    window.location.href = 'https://service.geekbang.org'
  },
  components: {
    banner,
    fixNav,
    switches,
    market,
    consultation,
    TFooter
  },
  computed: {
    items () {
      const arr = [{
        url: 'javascript:void(0)',
        pc_img: 'http://static.geekbang.org/infoq/5a27bc3d9bbc9.png?imageView2/0/',
        m_img: 'http://static.geekbang.org/infoq/5a27bf5162bdf.png?imageView2/0/'
      }]
      return arr
    },
    switches () {
      return [{
        colorImg: 'http://static.geekbang.org/infoq/5a27aff9da682.png?imageView2/0/',
        img: 'http://static.geekbang.org/infoq/5a27aff981a9f.png?imageView2/0/',
        title: '整合营销',
        subtitle: '打造企业营销影响力'
      }, {
        colorImg: 'http://static.geekbang.org/infoq/5a27aff8ea541.png?imageView2/0/',
        img: 'http://static.geekbang.org/infoq/5a27aff92acd3.png?imageView2/0/',
        title: '培训和咨询',
        subtitle: '技术人才全方位培养'
      }]
    },
    para () {
      const arr = [
        '',
        ''
      ]
      return arr
    }
  },
  methods: {
    switchItem (index) {
      this.currentIndex = index
    },
    ...mapMutations({
      setDivT: 'FIXNAV_DH'
    })
  },
  mounted () {
    window.onload = () => {
      var scrollTop = document.getElementById('site-main').offsetTop
      this.setDivT(scrollTop)
    }
    utils.shareInWeixin({
      timelineTitle: '极客邦企业服务',
      messageTitle: '极客邦企业服务',
      desc: '帮助企业和技术人成长'
    })
  }
}
</script>
<style scoped lang='sass'>
</style>
